module.exports = __webpack_public_path__ + "static/media/min_sida_userguide_1_0.cd9f7ce5.pdf";